import bannerTextAreaBlock from './banner-textarea';
export default bannerTextAreaBlock;
